import { WidgetBreadcrumbProps } from '@/types/cms'

const generateBreadcrumbList = (item: WidgetBreadcrumbProps) => {
  const itemList: Array<{
    item: {
      name: string
      '@id': string
    }
    '@type': 'ListItem'
    position: number
  }> = []
  const lastBCItem = item.model?.lastBCItem

  let jsonLd = undefined
  let pos = 0

  item.model?.sectionPath?.map((section: any, index: number) => {
    pos = index + 1
    itemList.push({
      item: {
        name: section.name,
        '@id': section.url,
      },
      '@type': 'ListItem',
      position: pos,
    })
  })

  if (lastBCItem) {
    itemList.push({
      item: {
        name: lastBCItem.name,
        '@id': lastBCItem.url,
      },
      '@type': 'ListItem',
      position: pos + 1,
    })
  }

  if (itemList.length > 0) {
    jsonLd = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: itemList,
    }
  }
  return jsonLd
}

const StructuredDataBreadcrumbList = ({ item }: { item: WidgetBreadcrumbProps }) => {
  const jsonLd = generateBreadcrumbList(item)

  if (!jsonLd) {
    return null
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonLd).replace(/</g, '\\u003c'),
      }}
    />
  )
}

export default StructuredDataBreadcrumbList
